var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 24,
    viewBox: "0 0 34 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6471 16.3362V6.9832C16.9674 8.54559 19.539 10.0549 22.5804 11.6821C20.0719 13.0733 16.9674 14.6342 13.6471 16.3362ZM32.1513 2.33151C31.5786 1.57691 30.6024 0.989523 29.5632 0.795056C26.5084 0.214973 7.45132 0.213323 4.39826 0.795056C3.56485 0.95129 2.82273 1.32893 2.18523 1.91566C-0.50093 4.40883 0.340785 17.7789 0.988253 19.9446C1.26052 20.8821 1.61249 21.5581 2.05576 22.0019C2.62686 22.5886 3.40878 22.9926 4.30694 23.1738C6.8221 23.694 19.7797 23.9849 29.51 23.2519C30.4065 23.0957 31.2 22.6787 31.8259 22.067C34.3095 19.5838 34.1402 5.46293 32.1513 2.33151Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.a28c9b0eef5ada9fcc98f82128234bc7.svg";
export { ForwardRef as ReactComponent };